import http from "@/apis/http";
import url from "@/config/url";

const api = url.tgBusiness.member.board;

export default {
    getData: (params) => http.post(api.search, params),
    getColumns: (params) => http.post(api.columns, params),
    getProfile: (params) => http.post(api.profile, params),
    getDirectpush: (params) => http.post(api.directpush, params),
}